// Single source of truth for tutorial programs, subjects, learning materials and chapter data.
// Identical original chapter lists are shared; subject keys keep each class's progress separate.

export const PROGRAMS = [
  {
    id: 'jee',
    label: 'IIT-JEE',
    tagline: 'Mains & Advanced',
    category: 'competitive',
    emoji: '⛛️',
    gradFrom: '#4f46e5',
    gradTo: '#7c3aed',
    stats: '3 subjects',
    description: 'Physics, Chemistry & Maths by IIT/NIT Alumni. Foundation to advanced.',
    subjects: [
      { title: 'Physics',     icon: 'physics',   route: '/tutorials/iitjee-physics',     subjectKey: 'iitjee-physics' },
      { title: 'Chemistry',   icon: 'chemistry', route: '/tutorials/iitjee-chemistry',   subjectKey: 'iitjee-chemistry' },
      { title: 'Mathematics', icon: 'math',      route: '/tutorials/iitjee-mathematics', subjectKey: 'iitjee-mathematics' },
    ],
  },
  {
    id: 'neet',
    label: 'NEET',
    tagline: 'UG Medical Entrance',
    category: 'competitive',
    emoji: '🧬',
    gradFrom: '#db2777',
    gradTo: '#9333ea',
    stats: '3 subjects',
    description: 'Physics, Chemistry & Biology by top Medical graduates. Full NCERT + beyond.',
    subjects: [
      { title: 'Physics',   icon: 'physics',   route: '/tutorials/iitjee-physics',   subjectKey: 'iitjee-physics' },
      { title: 'Chemistry', icon: 'chemistry', route: '/tutorials/iitjee-chemistry', subjectKey: 'iitjee-chemistry' },
      { title: 'Biology',   icon: 'biology',   route: '/tutorials/neet-biology',     subjectKey: 'neet-biology',     comingSoon: true },
    ],
  },
  {
    id: 'class12',
    label: 'Class 12',
    tagline: 'Boards + JEE/NEET Foundation',
    category: 'board',
    emoji: '📚',
    gradFrom: '#0891b2',
    gradTo: '#059669',
    stats: '4 subjects',
    description: 'PCM + Biology with board-exam depth and competitive edge beyond NCERT.',
    subjects: [
      { title: 'Physics',     icon: 'physics',   route: '/tutorials/class12-physics',     subjectKey: 'class12-physics' },
      { title: 'Chemistry',   icon: 'chemistry', route: '/tutorials/class12-chemistry',   subjectKey: 'class12-chemistry' },
      { title: 'Mathematics', icon: 'math',      route: '/tutorials/class12-mathematics', subjectKey: 'class12-mathematics' },
      { title: 'Biology',     icon: 'biology',   route: '/tutorials/class12-biology',     subjectKey: 'class12-biology',     comingSoon: true },
    ],
  },
  {
    id: 'class11',
    label: 'Class 11',
    tagline: 'Boards + JEE/NEET Foundation',
    category: 'board',
    emoji: '📖',
    gradFrom: '#0ea5e9',
    gradTo: '#6366f1',
    stats: '4 subjects',
    description: 'Boards + JEE/NEET Foundation. PCM + Biology with NCERT mastery and JEE/NEET readiness.',
    subjects: [
      { title: 'Physics',     icon: 'physics',   route: '/tutorials/class11-physics',     subjectKey: 'class11-physics' },
      { title: 'Chemistry',   icon: 'chemistry', route: '/tutorials/class11-chemistry',   subjectKey: 'class11-chemistry' },
      { title: 'Mathematics', icon: 'math',      route: '/tutorials/class11-mathematics', subjectKey: 'class11-mathematics' },
      { title: 'Biology',     icon: 'biology',   route: '/tutorials/class11-biology',     subjectKey: 'class11-biology',     comingSoon: true },
    ],
  },
  {
    id: 'class10',
    label: 'Class 10',
    tagline: 'Boards + Olympiad Ready',
    category: 'foundation',
    emoji: '🎓',
    gradFrom: '#f59e0b',
    gradTo: '#ef4444',
    stats: '2 subjects',
    description: 'Maths & Science with NCERT depth, board excellence and Olympiad readiness.',
    subjects: [
      { title: 'Mathematics', icon: 'math',    route: '/tutorials/class10-mathematics', subjectKey: 'class10-mathematics' },
      { title: 'Science',     icon: 'science', route: '/tutorials/class10-science',     subjectKey: 'class10-science' },
    ],
  },
  {
    id: 'class9',
    label: 'Class 9',
    tagline: 'Boards + Olympiad Ready',
    category: 'foundation',
    emoji: '📐',
    gradFrom: '#f97316',
    gradTo: '#eab308',
    stats: '2 subjects',
    description: 'Maths & Science with conceptual clarity that pays off for years to come.',
    subjects: [
      { title: 'Mathematics', icon: 'math',    route: '/tutorials/class9-mathematics', subjectKey: 'class9-mathematics' },
      { title: 'Science',     icon: 'science', route: '/tutorials/class9-science',     subjectKey: 'class9-science' },
    ],
  },
  {
    id: 'class8',
    label: 'Class 8',
    tagline: 'Boards + Olympiad Ready',
    category: 'foundation',
    emoji: '🔬',
    gradFrom: '#06b6d4',
    gradTo: '#6366f1',
    stats: '2 subjects',
    description: 'Maths & Science step up. Build the clarity that sets you apart in the years ahead.',
    subjects: [
      { title: 'Mathematics', icon: 'math',    route: '/tutorials/class8-mathematics', subjectKey: 'class8-mathematics' },
      { title: 'Science',     icon: 'science', route: '/tutorials/class8-science',     subjectKey: 'class8-science' },
    ],
  },
  {
    id: 'class7',
    label: 'Class 7',
    tagline: 'Boards + Olympiad Ready',
    category: 'foundation',
    emoji: '🔭',
    gradFrom: '#8b5cf6',
    gradTo: '#06b6d4',
    stats: '2 subjects',
    description: 'Maths & Science designed to make you love learning before exams even matter.',
    subjects: [
      { title: 'Mathematics', icon: 'math',    route: '/tutorials/class7-mathematics', subjectKey: 'class7-mathematics' },
      { title: 'Science',     icon: 'science', route: '/tutorials/class7-science',     subjectKey: 'class7-science' },
    ],
  },
  {
    id: 'class6',
    label: 'Class 6',
    tagline: 'Boards + Olympiad Ready',
    category: 'foundation',
    emoji: '✏️',
    gradFrom: '#10b981',
    gradTo: '#3b82f6',
    stats: '2 subjects',
    description: 'The right start. Master Maths & Science fundamentals from day one.',
    subjects: [
      { title: 'Mathematics', icon: 'math',    route: '/tutorials/class6-mathematics', subjectKey: 'class6-mathematics' },
      { title: 'Science',     icon: 'science', route: '/tutorials/class6-science',     subjectKey: 'class6-science' },
    ],
  },
];

export const TUTORIAL_SUBJECTS = [
  ...new Map(PROGRAMS.flatMap(program => program.subjects).map(subject => [subject.subjectKey, subject])).values(),
];

export const PROGRAM_SUBJECT_KEYS = Object.fromEntries(
  PROGRAMS.map(program => [
    program.id,
    program.subjects.filter(subject => !subject.comingSoon).map(subject => subject.subjectKey),
  ])
);

// Sources refer to arrays on the existing chapter definitions.
// Add file/test tabs with a source, or link tabs with a route, here.
export const TUTORIAL_MATERIAL_TABS = [
  { id: 'lectures', label: 'Lectures', kind: 'lectures', source: 'lectures' },
  { id: 'tests', label: 'Mock tests', kind: 'tests', source: 'tests' },
  { id: 'practice', label: 'Practice questions', kind: 'files', source: 'dpps' },
  { id: 'materials', label: 'Study materials', kind: 'link', route: '/study-materials' },
  { id: 'doubts', label: 'Ask a doubt', kind: 'link', route: '/doubt-portal24*7' },
];

export const TUTORIAL_TEST_ROUTES = {
  jee2020_1_1: '/test/jee2020_1_1',
};

const iitjee_physics_sections = [
  {
    id: "mechanics",
    name: "Mechanics",
    chapters: [
      {
        id: "chapter-1-units-dimensions-errors",
        title: "Chapter 1: Units, Dimensions & Error Analysis",
        storagePath: "lectures/iitjee/physics/mechanics/units-dimensions",
        
        // --- UPDATED to be arrays ---
        dpps: [
          { name: "P1. Pratice Questions Set1 (Beginner Level)", fileName: "Set DPP Beginner.pdf" },
          { name: "P2. Pratice Questions Set2 (Advance Level)", fileName: "Inequality & Modulas DPP.pdf" }
        ],
        tests: [
          { name: "T1. Chapterwise Test 1", testId: "jee2020_1_1" },
          { name: "T2. Chapterwise Test 2", testId: "units_chapter_test" }
        ],
        // -----------------------------
        
        lectures: [
          { id: "phy-001", title: "L1. Hanuman Chalisa - Shree Ganeshay Namah", fileName: "Hanuman_Chalisa_n.mp4" },

        ],
      },
            {
        id: "chapter-2-kinematics",
        title: "Chapter 2: Kinematics",
        storagePath: "lectures/iitjee/physics/mechanics/kinematics",
        dpps: [
          { name: "Kinematics DPP", fileName: "Kinematics_DPP.pdf" }
        ],
        tests: [
          { name: "Kinematics Test", testId: "chapter-test-kinematics" }
        ],
        lectures: [
          { id: "kin-001", title: "L1. Introduction to Kinematics, Distance & Displacement", fileName: "L1_Introduction_to_Kinematics_Distance_and_Displacement.mp4" },
          { id: "kin-002", title: "L2. Average Speed & Velocity", fileName: "L2_Average_Speed_and_Velocity.mp4" },
          { id: "kin-003", title: "L3. Instantaneous Speed & Velocity", fileName: "L3_Instantaneous_Speed_and_Velocity.mp4" },
          { id: "kin-004", title: "L4. Acceleration", fileName: "L4_Acceleration.mp4" },
          { id: "kin-005", title: "L5. Practice Questions on Basic Concepts", fileName: "L5_Practice_Questions_on_Basic_Concepts.mp4" },
          { id: "kin-006", title: "L6. Graphical Analysis", fileName: "L6_Graphical_Analysis.mp4" },
          { id: "kin-007", title: "L7. Equations of Motion", fileName: "L7_Equations_of_Motion.mp4" },
          { id: "kin-008", title: "L8. Motion Under Gravity", fileName: "L8_Motion_Under_Gravity.mp4" },
          { id: "kin-009", title: "L9. Graphs & Questions on Motion Under Gravity", fileName: "L9_Graphs_and_Questions_on_Motion_Under_Gravity.mp4" },
          { id: "kin-010", title: "L10. Relative Motion in 1D", fileName: "L10_Relative_Motion_in_1D.mp4" },
          { id: "kin-011", title: "L11. 2D Motion in Kinematics", fileName: "L11_2D_Motion_in_Kinematics.mp4" },
          { id: "kin-012", title: "L12. Relative Motion in 2D", fileName: "L12_Relative_Motion_in_2D.mp4" },
          { id: "kin-013", title: "L13. Rain Problem", fileName: "L13_Rain_Problem.mp4" },
          { id: "kin-014", title: "L14. River Boat Problem", fileName: "L14_River_Boat.mp4" },
          { id: "kin-015", title: "L15. Velocity of Approach & Separation, and Collision", fileName: "L15_Velocity_of_Approach_and_Separation_and_Collision.mp4" },
          { id: "kin-016", title: "L16. Projectile — Ground to Ground", fileName: "L16_Projectile_Ground_to_Ground.mp4" },
          { id: "kin-017", title: "L17. Horizontal Projectile & Projectile from Tower", fileName: "L17_Horizontal_Projectile_and_Projectile_from_Tower.mp4" },
          { id: "kin-018", title: "L18. Projectile from Moving Platform & Misc. Questions", fileName: "L18_Projectile_from_Moving_Platform_and_Misc_Questions.mp4" },
          { id: "kin-019", title: "L19. Projection on Inclined Plane", fileName: "L19_Projection_on_Inclined_Plane.mp4" },
        ],
      },
      {
        id: "chapter-3-laws-of-motion",
        title: "Chapter 3: Newtons Laws of Motion",
        storagePath: "lectures/iitjee/physics/mechanics/laws-of-motion",
        dpps: [],
        tests: [],
        lectures: [
          { id: "nlm-001", title: "L1. Intro & Types of Forces", fileName: "L1_Intro_and_Types_of_Forces.mp4" },
          { id: "nlm-002", title: "L2. Newton Third Law, Free Body Diagram & First Law", fileName: "L2_Newton_Third_Law_Free_Body_Diagram_and_First_Law.mp4" },
          { id: "nlm-003", title: "L3. First Law Questions", fileName: "L3_First_Law_Questions.mp4" },
          { id: "nlm-004", title: "L4. Newton Second Law", fileName: "L4_Newton_Second_Law.mp4" },
          { id: "nlm-005", title: "L5. Second Law Questions", fileName: "L5_Second_Law_Questions.mp4" },
          { id: "nlm-006", title: "L6. Constraint Motion", fileName: "L6_Constraint_Motion.mp4" },
          { id: "nlm-007", title: "L7. Constraint & Wedge Constraint", fileName: "L7_Constraint_and_Wedge_Constraint.mp4" },
          { id: "nlm-008", title: "L8. Newton Third Law (Applications)", fileName: "L8_Newton_Third_Law.mp4" },
          { id: "nlm-009", title: "L9. Weighing Machine", fileName: "L9_Weighing_Machine.mp4" },
          { id: "nlm-010", title: "L10. Spring Force", fileName: "L10_Spring_Force.mp4" },
          { id: "nlm-011", title: "L11. Spring Questions & Combinations", fileName: "L11_Spring_Questions_and_Combinations.mp4" },
          { id: "nlm-012", title: "L12. Pseudo Force", fileName: "L12_Pseudo_Force.mp4" },
          { id: "nlm-013", title: "L13. Miscellaneous — Chain & Rocket", fileName: "L13_Miscellaneous_Chain_and_Rocket.mp4" },
        ],
      },
      {
        id: "chapter-4-friction",
        title: "Chapter 4: Friction",
        storagePath: "lectures/iitjee/physics/mechanics/friction",
        dpps: [],
        tests: [],
        lectures: [
          { id: "fri-001", title: "L1. Introduction to Friction", fileName: "L1_Intro.mp4" },
          { id: "fri-002", title: "L2. Kinetic Friction", fileName: "L2_Kinetic_Friction.mp4" },
          { id: "fri-003", title: "L3. Static Friction", fileName: "L3_Static_Friction.mp4" },
          { id: "fri-004", title: "L4. Contact Angle & Forces", fileName: "L4_Contact_Angle_and_Forces.mp4" },
          { id: "fri-005", title: "L5. Angle of Repose", fileName: "L5_Repose_Angle.mp4" },
          { id: "fri-006", title: "L6. Block on Block", fileName: "L6_Block_on_Block.mp4" },
        ],
      },
{
        id: "chapter-5-work-energy-power",
        title: "Chapter 5: Work, Energy & Power",
        storagePath: "lectures/iitjee/physics/mechanics/work-energy-power",
        dpps: [],
        tests: [],
        lectures: [
          
        ],
      },
      {
        id: "chapter-6-rotational-motion",
        title: "Chapter 6: Rotational Motion & Centre of Mass",
        storagePath: "lectures/iitjee/physics/mechanics/rotational-motion",
        dpps: [],
        tests: [],
        lectures: [
          
        ],
      },
      {
        id: "chapter-7-gravitation",
        title: "Chapter 7: Gravitation",
        storagePath: "lectures/iitjee/physics/mechanics/gravitation",
        dpps: [],
        tests: [],
        lectures: [
          
        ],
      },
    ],
  },
  {
    id: "properties-thermodynamics",
    name: "Properties of Matter & Thermodynamics",
    chapters: [
      {
        id: "chapter-8-properties-of-matter",
        title: "Chapter 8: Properties of Solids & Fluids",
        storagePath: "lectures/iitjee/physics/properties-thermo/properties-of-matter",
        dpps: [],
        tests: [],
        lectures: [
          
        ],
      },
      {
        id: "chapter-9-thermal-properties-heat",
        title: "Chapter 9: Thermal Properties & Heat Transfer",
        storagePath: "lectures/iitjee/physics/properties-thermo/thermal-properties",
        dpps: [],
        tests: [],
        lectures: [
          
        ],
      },
      {
        id: "chapter-10-thermodynamics-ktg",
        title: "Chapter 10: Thermodynamics & Kinetic Theory (KTG)",
        storagePath: "lectures/iitjee/physics/properties-thermo/thermodynamics-ktg",
        dpps: [],
        tests: [],
        lectures: [
          
        ],
      },
    ],
  },
  {
    id: "waves-optics",
    name: "Waves & Optics",
    chapters: [
      {
        id: "chapter-11-shm",
        title: "Chapter 11: Simple Harmonic Motion (Oscillations)",
        storagePath: "lectures/iitjee/physics/waves-optics/shm",
        dpps: [],
        tests: [],
        lectures: [
           ],
      },
      {
        id: "chapter-12-waves",
        title: "Chapter 12: Waves (String & Sound)",
        storagePath: "lectures/iitjee/physics/waves-optics/waves",
        dpps: [],
        tests: [],
        lectures: [
          
        ],
      },
      {
        id: "chapter-13-ray-optics",
        title: "Chapter 13: Ray Optics & Optical Instruments",
        storagePath: "lectures/iitjee/physics/waves-optics/ray-optics",
        dpps: [],
        tests: [],
        lectures: [
          
        ],
      },
      {
        id: "chapter-14-wave-optics",
        title: "Chapter 14: Wave Optics",
        storagePath: "lectures/iitjee/physics/waves-optics/wave-optics",
        dpps: [],
        tests: [],
        lectures: [
          
        ],
      },
    ],
  },
  {
    id: "electricity-magnetism",
    name: "Electricity & Magnetism",
    chapters: [
      {
        id: "chapter-15-electrostatics",
        title: "Chapter 15: Electrostatics",
        storagePath: "lectures/iitjee/physics/electromagnetism/electrostatics",
        dpps: [],
        tests: [],
        lectures: [
          
        ],
      },
      {
        id: "chapter-16-current-electricity",
        title: "Chapter 16: Current Electricity",
        storagePath: "lectures/iitjee/physics/electromagnetism/current-electricity",
        dpps: [],
        tests: [],
        lectures: [
          
        ],
      },
      {
        id: "chapter-17-magnetic-effects",
        title: "Chapter 17: Magnetic Effects of Current & Magnetism",
        storagePath: "lectures/iitjee/physics/electromagnetism/magnetic-effects",
        dpps: [],
        tests: [],
        lectures: [
          
        ],
      },
      {
        id: "chapter-18-emi-ac",
        title: "Chapter 18: EMI & Alternating Current (AC)",
        storagePath: "lectures/iitjee/physics/electromagnetism/emi-ac",
        dpps: [],
        tests: [],
        lectures: [
          
        ],
      },
      {
        id: "chapter-19-em-waves",
        title: "Chapter 19: Electromagnetic Waves",
        storagePath: "lectures/iitjee/physics/electromagnetism/em-waves",
        dpps: [],
        tests: [],
        lectures: [
          
        ],
      },
    ],
  },
  {
    id: "modern-physics",
    name: "Modern Physics",
    chapters: [
      {
        id: "chapter-20-dual-nature",
        title: "Chapter 20: Dual Nature of Matter & Radiation",
        storagePath: "lectures/iitjee/physics/modern-physics/dual-nature",
        dpps: [],
        tests: [],
        lectures: [
          
          
        ],
      },
      {
        id: "chapter-21-atoms-nuclei",
        title: "Chapter 21: Atoms & Nuclei",
        storagePath: "lectures/iitjee/physics/modern-physics/atoms-nuclei",
        dpps: [],
        tests: [],
        lectures: [
          
        ],
      },
      {
        id: "chapter-22-semiconductors",
        title: "Chapter 22: Semiconductor Electronics",
        storagePath: "lectures/iitjee/physics/modern-physics/semiconductors",
        dpps: [],
        tests: [],
        lectures: [
          
        ],
      },
      {
        id: "chapter-23-communication-systems",
        title: "Chapter 23: Communication Systems",
        storagePath: "lectures/iitjee/physics/modern-physics/communication",
        dpps: [],
        tests: [],
        lectures: [
          
        ],
      },
    ],
  },
];

const iitjee_chemistry_sections = [
  {
    id: "physical-chemistry",
    name: "Physical Chemistry",
    chapters: [
      {
        id: "chapter-1-mole-concept",
        title: "Chapter 1: Mole Concept & Redox Reactions",
        storagePath: "lectures/iitjee/chem/physical/mole-concept",
        dpps: [
          { name: "C1. Stoichiometry & Concentration Terms", fileName: "Mole_DPP_Set1.pdf" },
          { name: "C2. Redox Balancing (Ion-Electron Method)", fileName: "Redox_DPP_Set2.pdf" }
        ],
        tests: [
          { name: "T1. Mole Concept Test", testId: "chem_mole_t1" },
          { name: "T2. Redox Reactions Test", testId: "chem_redox_t1" }
        ],
        lectures: [
          { id: "chem-001", title: "L1. Calculation of Moles & Empirical Formula", fileName: "L1_Stoichiometry.mp4" },
          { id: "chem-002", title: "L2. Concentration Terms (M, m, X)", fileName: "L2_Concentration.mp4" },
          { id: "chem-003", title: "L3. N-factor & Balancing Redox", fileName: "L3_Redox.mp4" },
        ],
      },
      {
        id: "chapter-2-atomic-structure",
        title: "Chapter 2: Atomic Structure",
        storagePath: "lectures/iitjee/chem/physical/atomic-structure",
        dpps: [
          { name: "C1. Bohr's Model & Photoelectric Effect", fileName: "Atomic_DPP_1.pdf" },
          { name: "C2. Quantum Numbers & Orbitals", fileName: "Atomic_DPP_2.pdf" }
        ],
        tests: [
          { name: "T1. Atomic Spectra Test", testId: "chem_atomic_t1" },
          { name: "T2. Schrodinger Wave Equation Test", testId: "chem_atomic_t2" }
        ],
        lectures: [
          { id: "chem-004", title: "L1. Bohr’s Theory & Hydrogen Spectrum", fileName: "L1_Bohr_Theory.mp4" },
          { id: "chem-005", title: "L2. Quantum Mechanical Model", fileName: "L2_Quantum_Model.mp4" },
        ],
      },
      { id: "chapter-3-thermo", title: "Chapter 3: Chemical Thermodynamics", storagePath: "lectures/iitjee/chem/physical/thermo", dpps: [], tests: [], lectures: [] },
      { id: "chapter-4-equilibrium", title: "Chapter 4: Chemical & Ionic Equilibrium", storagePath: "lectures/iitjee/chem/physical/equilibrium", dpps: [], tests: [], lectures: [] },
    ],
  },
  {
    id: "inorganic-chemistry",
    name: "Inorganic Chemistry",
    chapters: [
      { id: "chapter-5-bonding", title: "Chapter 5: Chemical Bonding", storagePath: "lectures/iitjee/chem/inorganic/bonding", dpps: [], tests: [], lectures: [] },
      { id: "chapter-6-periodic", title: "Chapter 6: Periodic Table", storagePath: "lectures/iitjee/chem/inorganic/periodic", dpps: [], tests: [], lectures: [] },
      { id: "chapter-7-pblock", title: "Chapter 7: p-Block Elements", storagePath: "lectures/iitjee/chem/inorganic/pblock", dpps: [], tests: [], lectures: [] },
    ],
  },
  {
    id: "organic-chemistry",
    name: "Organic Chemistry",
    chapters: [
      { id: "chapter-8-goc", title: "Chapter 8: General Organic Chemistry (GOC)", storagePath: "lectures/iitjee/chem/organic/goc", dpps: [], tests: [], lectures: [] },
      { id: "chapter-9-hydrocarbons", title: "Chapter 9: Hydrocarbons", storagePath: "lectures/iitjee/chem/organic/hydrocarbons", dpps: [], tests: [], lectures: [] },
      { id: "chapter-10-carbonyl", title: "Chapter 10: Aldehydes & Ketones", storagePath: "lectures/iitjee/chem/organic/carbonyl", dpps: [], tests: [], lectures: [] },
    ],
  }
];

const iitjee_mathematics_sections = [
  {
    id: "algebra",
    name: "Algebra",
    chapters: [
      {
        id: "chapter-1-sets-relations-functions",
        title: "Chapter 1: Sets, Relations & Functions",
        storagePath: "lectures/iitjee/math/algebra/sets-relations",
        dpps: [
          { name: "M1. Practice Questions Set 1 (Types of Relations)", fileName: "Relations_DPP_Set1.pdf" },
          { name: "M2. Practice Questions Set 2 (Domain & Range)", fileName: "Functions_DPP_Set2.pdf" }
        ],
        tests: [
          { name: "T1. Relations Topic Test", testId: "math_sets_t1" },
          { name: "T2. Functions Cumulative Test", testId: "math_sets_t2" }
        ],
        lectures: [
          { id: "math-001", title: "L1. Introduction", fileName: "L1_Introduction.mp4" },
          { id: "math-002", title: "L2. Set Theory", fileName: "L2_Set_Theory.mp4" },
        ],
      },
      {
        id: "chapter-2-complex-numbers",
        title: "Chapter 2: Complex Numbers & Quadratic Equations",
        storagePath: "lectures/iitjee/math/algebra/complex-numbers",
        dpps: [
          { name: "M1. Complex Numbers (Algebraic Form)", fileName: "Complex_DPP_1.pdf" },
          { name: "M2. Quadratic Equations (Nature of Roots)", fileName: "Quadratic_DPP_1.pdf" }
        ],
        tests: [
          { name: "T1. Complex Numbers Test", testId: "math_complex_t1" },
          { name: "T2. Quadratic Equations Test", testId: "math_quad_t1" }
        ],
        lectures: [
          { id: "math-004", title: "L1. Geometry of Complex Numbers", fileName: "L1_Complex_Geom.mp4" },
          { id: "math-005", title: "L2. De-Moivre’s Theorem & Roots", fileName: "L2_DMT.mp4" },
        ],
      },
      { id: "chapter-3-matrices", title: "Chapter 3: Matrices & Determinants", storagePath: "lectures/iitjee/math/algebra/matrices", dpps: [], tests: [], lectures: [] },
      { id: "chapter-4-pnc", title: "Chapter 4: Permutations & Combinations", storagePath: "lectures/iitjee/math/algebra/pnc", dpps: [], tests: [], lectures: [] },
    ],
  },
  {
    id: "calculus",
    name: "Calculus",
    chapters: [
      { id: "chapter-5-limits", title: "Chapter 5: Limits, Continuity & Differentiability", storagePath: "lectures/iitjee/math/calculus/limits", dpps: [], tests: [], lectures: [] },
      { id: "chapter-6-integrals", title: "Chapter 6: Integral Calculus", storagePath: "lectures/iitjee/math/calculus/integrals", dpps: [], tests: [], lectures: [] },
      { id: "chapter-7-diff-eq", title: "Chapter 7: Differential Equations", storagePath: "lectures/iitjee/math/calculus/diff-eq", dpps: [], tests: [], lectures: [] },
    ],
  },
  {
    id: "coordinate-geometry",
    name: "Coordinate Geometry",
    chapters: [
      { id: "chapter-8-lines", title: "Chapter 8: Straight Lines & Circles", storagePath: "lectures/iitjee/math/geometry/lines", dpps: [], tests: [], lectures: [] },
      { id: "chapter-9-conics", title: "Chapter 9: Conic Sections", storagePath: "lectures/iitjee/math/geometry/conics", dpps: [], tests: [], lectures: [] },
    ],
  },
  {
    id: "vectors-3d",
    name: "Vectors & 3D Geometry",
    chapters: [
      { id: "chapter-10-vectors", title: "Chapter 10: Vector Algebra", storagePath: "lectures/iitjee/math/vectors/algebra", dpps: [], tests: [], lectures: [] },
      { id: "chapter-11-3d", title: "Chapter 11: Three Dimensional Geometry", storagePath: "lectures/iitjee/math/vectors/3d", dpps: [], tests: [], lectures: [] },
    ],
  }
];

const class12_physics_chapters = [
  {
    id: "chapter-1",
    title: "Chapter 1: Electrostatic Potential & Capacitance",
    storagePath: "lectures/class12/physics/electrostatics",
    dpps: [{ name: "DPP 1: Basic Potential", fileName: "dpp1.pdf" }],
    tests: [{ name: "Topic Test: Capacitance", testId: "c12_ch1_test" }],
    lectures: [
      { id: 1, title: "L1. Coulomb's Law & Forces", fileName: "l1_coulomb.mp4" },
      { id: 2, title: "L2. Electric Field Intensity", fileName: "l2_field.mp4" },
      { id: 3, title: "L3. Gauss's Law Applications", fileName: "l3_gauss.mp4" },
    ],
  },
  {
    id: "chapter-2",
    title: "Chapter 2: Current Electricity",
    storagePath: "lectures/class12/physics/current-electricity",
    dpps: [], tests: [],
    lectures: [
      { id: 4, title: "L1. Ohm's Law & Drift Velocity", fileName: "l4_ohm.mp4" },
      { id: 5, title: "L2. Kirchhoff's Circuit Laws", fileName: "l5_kirchhoff.mp4" },
    ],
  },
  {
    id: "chapter-3",
    title: "Chapter 3: Magnetic Effects & Magnetism",
    storagePath: "lectures/class12/physics/magnetism",
    dpps: [], tests: [],
    lectures: [
      { id: 7, title: "L1. Biot-Savart Law", fileName: "l7_biot.mp4" },
      { id: 8, title: "L2. Ampere’s Circuital Law", fileName: "l8_ampere.mp4" },
    ],
  },
  { id: "chapter-4", title: "Chapter 4: Electromagnetic Induction", storagePath: "lectures/class12/physics/emi", dpps: [], tests: [], lectures: [] },
  { id: "chapter-5", title: "Chapter 5: Alternating Current", storagePath: "lectures/class12/physics/ac", dpps: [], tests: [], lectures: [] },
  { id: "chapter-6", title: "Chapter 6: Electromagnetic Waves", storagePath: "lectures/class12/physics/em-waves", dpps: [], tests: [], lectures: [] },
  { id: "chapter-7", title: "Chapter 7: Ray Optics & Instruments", storagePath: "lectures/class12/physics/ray-optics", dpps: [], tests: [], lectures: [] },
  { id: "chapter-8", title: "Chapter 8: Wave Optics", storagePath: "lectures/class12/physics/wave-optics", dpps: [], tests: [], lectures: [] },
  { id: "chapter-9", title: "Chapter 9: Dual Nature of Matter", storagePath: "lectures/class12/physics/dual-nature", dpps: [], tests: [], lectures: [] },
  { id: "chapter-10", title: "Chapter 10: Atoms & Nuclei", storagePath: "lectures/class12/physics/atoms-nuclei", dpps: [], tests: [], lectures: [] },
  { id: "chapter-11", title: "Chapter 11: Semiconductor Electronics", storagePath: "lectures/class12/physics/semiconductors", dpps: [], tests: [], lectures: [] },
];

const class12_chemistry_chapters = [
  {
    id: "chapter-1",
    title: "Chapter 1: Solutions",
    storagePath: "lectures/class12/chemistry/solutions",
    dpps: [
      { name: "DPP 1: Raoult's Law & Vapor Pressure", fileName: "c12_ch1_dpp1.pdf" },
      { name: "DPP 2: Colligative Properties", fileName: "c12_ch1_dpp2.pdf" }
    ],
    tests: [
      { name: "Topic Test: Ideal & Non-Ideal Solutions", testId: "c12_ch1_t1" },
      { name: "Chapter Test: Solutions", testId: "c12_ch1_t2" }
    ],
    lectures: [
      { id: 1, title: "L1. Types of Solutions & Solubility", fileName: "l1_solubility.mp4" },
      { id: 2, title: "L2. Henry's Law & Raoult's Law", fileName: "l2_laws.mp4" },
      { id: 3, title: "L3. Elevation in Boiling Point & Osmotic Pressure", fileName: "l3_colligative.mp4" },
    ],
  },
  {
    id: "chapter-2",
    title: "Chapter 2: Electrochemistry",
    storagePath: "lectures/class12/chemistry/electrochemistry",
    dpps: [], tests: [],
    lectures: [
      { id: 4, title: "L1. Galvanic Cells & Nernst Equation", fileName: "l4_galvanic.mp4" },
      { id: 5, title: "L2. Electrolysis & Faraday's Laws", fileName: "l5_electrolysis.mp4" },
    ],
  },
  { id: "chapter-3", title: "Chapter 3: Chemical Kinetics", storagePath: "lectures/class12/chemistry/kinetics", dpps: [], tests: [], lectures: [] },
  { id: "chapter-4", title: "Chapter 4: d & f Block Elements", storagePath: "lectures/class12/chemistry/df-block", dpps: [], tests: [], lectures: [] },
  { id: "chapter-5", title: "Chapter 5: Coordination Compounds", storagePath: "lectures/class12/chemistry/coordination", dpps: [], tests: [], lectures: [] },
  { id: "chapter-6", title: "Chapter 6: Haloalkanes & Haloarenes", storagePath: "lectures/class12/chemistry/haloalkanes", dpps: [], tests: [], lectures: [] },
  { id: "chapter-7", title: "Chapter 7: Alcohols, Phenols & Ethers", storagePath: "lectures/class12/chemistry/alcohols", dpps: [], tests: [], lectures: [] },
  { id: "chapter-8", title: "Chapter 8: Aldehydes, Ketones & Carboxylic Acids", storagePath: "lectures/class12/chemistry/carbonyl", dpps: [], tests: [], lectures: [] },
  { id: "chapter-9", title: "Chapter 9: Amines", storagePath: "lectures/class12/chemistry/amines", dpps: [], tests: [], lectures: [] },
  { id: "chapter-10", title: "Chapter 10: Biomolecules", storagePath: "lectures/class12/chemistry/biomolecules", dpps: [], tests: [], lectures: [] },
];

const class12_mathematics_chapters = [
  {
    id: "chapter-1",
    title: "Chapter 1: Relations & Functions",
    storagePath: "lectures/class12/math/relations-functions",
    dpps: [
      { name: "DPP 1: Types of Relations", fileName: "m12_ch1_dpp1.pdf" },
      { name: "DPP 2: Composition of Functions", fileName: "m12_ch1_dpp2.pdf" }
    ],
    tests: [
      { name: "Topic Test: Bijective Functions", testId: "m12_ch1_t1" },
      { name: "Chapter Test: Relations & Functions", testId: "m12_ch1_t2" }
    ],
    lectures: [
      { id: 1, title: "L1. Reflexive, Symmetric & Transitive Relations", fileName: "l1_relations.mp4" },
      { id: 2, title: "L2. One-to-One and Onto Functions", fileName: "l2_functions.mp4" },
      { id: 3, title: "L3. Composite and Inverse Functions", fileName: "l3_inverse.mp4" },
    ],
  },
  {
    id: "chapter-2",
    title: "Chapter 2: Inverse Trigonometric Functions",
    storagePath: "lectures/class12/math/itf",
    dpps: [], tests: [],
    lectures: [
      { id: 4, title: "L1. Principal Value Branches", fileName: "l4_itf_basics.mp4" },
      { id: 5, title: "L2. Properties of Inverse Trig Functions", fileName: "l5_itf_props.mp4" },
    ],
  },
  { id: "chapter-3", title: "Chapter 3: Matrices", storagePath: "lectures/class12/math/matrices", dpps: [], tests: [], lectures: [] },
  { id: "chapter-4", title: "Chapter 4: Determinants", storagePath: "lectures/class12/math/determinants", dpps: [], tests: [], lectures: [] },
  { id: "chapter-5", title: "Chapter 5: Continuity & Differentiability", storagePath: "lectures/class12/math/continuity", dpps: [], tests: [], lectures: [] },
  { id: "chapter-6", title: "Chapter 6: Application of Derivatives", storagePath: "lectures/class12/math/aod", dpps: [], tests: [], lectures: [] },
  { id: "chapter-7", title: "Chapter 7: Integrals", storagePath: "lectures/class12/math/integrals", dpps: [], tests: [], lectures: [] },
  { id: "chapter-8", title: "Chapter 8: Application of Integrals", storagePath: "lectures/class12/math/aoi", dpps: [], tests: [], lectures: [] },
  { id: "chapter-9", title: "Chapter 9: Differential Equations", storagePath: "lectures/class12/math/diff-eq", dpps: [], tests: [], lectures: [] },
  { id: "chapter-10", title: "Chapter 10: Vector Algebra", storagePath: "lectures/class12/math/vectors", dpps: [], tests: [], lectures: [] },
  { id: "chapter-11", title: "Chapter 11: Three Dimensional Geometry", storagePath: "lectures/class12/math/3d-geometry", dpps: [], tests: [], lectures: [] },
  { id: "chapter-12", title: "Chapter 12: Linear Programming", storagePath: "lectures/class12/math/lpp", dpps: [], tests: [], lectures: [] },
  { id: "chapter-13", title: "Chapter 13: Probability", storagePath: "lectures/class12/math/probability", dpps: [], tests: [], lectures: [] },
];

const class11_chemistry_chapters = [
  {
    id: "chapter-1",
    title: "Chapter 1: Some Basic Concepts of Chemistry",
    storagePath: "lectures/class11/chemistry/basic-concepts",
    dpps: [
      { name: "DPP 1: Mole Concept Basics", fileName: "c11_ch1_dpp1.pdf" },
      { name: "DPP 2: Limiting Reagents", fileName: "c11_ch1_dpp2.pdf" }
    ],
    tests: [
      { name: "Topic Test: Stoichiometry", testId: "c11_ch1_t1" },
      { name: "Chapter Test: Basic Concepts", testId: "c11_ch1_t2" }
    ],
    lectures: [
      { id: 1, title: "L1. Dalton's Atomic Theory & Laws", fileName: "c11_ch1_l1.mp4" },
      { id: 2, title: "L2. Mole Concept & Atomic Mass", fileName: "c11_ch1_l2.mp4" },
      { id: 3, title: "L3. Concentration Terms (Molarity/Molality)", fileName: "c11_ch1_l3.mp4" },
    ],
  },
  {
    id: "chapter-2",
    title: "Chapter 2: Structure of Atom",
    storagePath: "lectures/class11/chemistry/atomic-structure",
    dpps: [
        { name: "DPP 1: Bohr's Model", fileName: "c11_ch2_dpp1.pdf" },
        { name: "DPP 2: Quantum Numbers", fileName: "c11_ch2_dpp2.pdf" }
    ],
    tests: [
        { name: "Test 1: Photoelectric Effect", testId: "c11_ch2_t1" },
        { name: "Test 2: Dual Nature of Matter", testId: "c11_ch2_t2" }
    ],
    lectures: [
      { id: 4, title: "L1. Discovery of Subatomic Particles", fileName: "c11_ch2_l1.mp4" },
      { id: 5, title: "L2. Heisenberg's Uncertainty Principle", fileName: "c11_ch2_l2.mp4" },
    ],
  },
  { id: "chapter-3", title: "Chapter 3: Classification of Elements & Periodicity", storagePath: "lectures/class11/chemistry/periodic", dpps: [], tests: [], lectures: [] },
  { id: "chapter-4", title: "Chapter 4: Chemical Bonding & Molecular Structure", storagePath: "lectures/class11/chemistry/bonding", dpps: [], tests: [], lectures: [] },
  { id: "chapter-5", title: "Chapter 5: Chemical Thermodynamics", storagePath: "lectures/class11/chemistry/thermo", dpps: [], tests: [], lectures: [] },
  { id: "chapter-6", title: "Chapter 6: Equilibrium", storagePath: "lectures/class11/chemistry/equilibrium", dpps: [], tests: [], lectures: [] },
  { id: "chapter-7", title: "Chapter 7: Redox Reactions", storagePath: "lectures/class11/chemistry/redox", dpps: [], tests: [], lectures: [] },
  { id: "chapter-8", title: "Chapter 8: Organic Chemistry: Basic Principles", storagePath: "lectures/class11/chemistry/organic-basics", dpps: [], tests: [], lectures: [] },
  { id: "chapter-9", title: "Chapter 9: Hydrocarbons", storagePath: "lectures/class11/chemistry/hydrocarbons", dpps: [], tests: [], lectures: [] },
];

const class11_mathematics_chapters = [
  {
    id: "chapter-1",
    title: "Chapter 1: Sets",
    storagePath: "lectures/class11/math/sets",
    dpps: [
      { name: "DPP 1: Representation of Sets", fileName: "m11_ch1_dpp1.pdf" },
      { name: "DPP 2: Venn Diagrams & Operations", fileName: "m11_ch1_dpp2.pdf" }
    ],
    tests: [
      { name: "Topic Test: Power Sets", testId: "m11_ch1_t1" },
      { name: "Chapter Test: Sets", testId: "m11_ch1_t2" }
    ],
    lectures: [
      { id: 1, title: "L1. Roster and Set-Builder Form", fileName: "m11_ch1_l1.mp4" },
      { id: 2, title: "L2. Types of Sets & Subsets", fileName: "m11_ch1_l2.mp4" },
      { id: 3, title: "L3. Operations on Sets", fileName: "m11_ch1_l3.mp4" },
    ],
  },
  {
    id: "chapter-2",
    title: "Chapter 2: Relations & Functions",
    storagePath: "lectures/class11/math/relations-functions",
    dpps: [
        { name: "DPP 1: Cartesian Products", fileName: "m11_ch2_dpp1.pdf" },
        { name: "DPP 2: Domain and Range", fileName: "m11_ch2_dpp2.pdf" }
    ],
    tests: [
        { name: "Test 1: Signum & Step Functions", testId: "m11_ch2_t1" },
        { name: "Test 2: Modulus Functions", testId: "m11_ch2_t2" }
    ],
    lectures: [
      { id: 4, title: "L1. Ordered Pairs & Cartesian Products", fileName: "m11_ch2_l1.mp4" },
      { id: 5, title: "L2. Domain, Codomain & Range", fileName: "m11_ch2_l2.mp4" },
    ],
  },
  { id: "chapter-3", title: "Chapter 3: Trigonometric Functions", storagePath: "lectures/class11/math/trigo", dpps: [], tests: [], lectures: [] },
  { id: "chapter-4", title: "Chapter 4: Complex Numbers & Quadratic Equations", storagePath: "lectures/class11/math/complex", dpps: [], tests: [], lectures: [] },
  { id: "chapter-5", title: "Chapter 5: Linear Inequalities", storagePath: "lectures/class11/math/inequalities", dpps: [], tests: [], lectures: [] },
  { id: "chapter-6", title: "Chapter 6: Permutations & Combinations", storagePath: "lectures/class11/math/pnc", dpps: [], tests: [], lectures: [] },
  { id: "chapter-7", title: "Chapter 7: Binomial Theorem", storagePath: "lectures/class11/math/binomial", dpps: [], tests: [], lectures: [] },
  { id: "chapter-8", title: "Chapter 8: Sequences & Series", storagePath: "lectures/class11/math/sequences", dpps: [], tests: [], lectures: [] },
  { id: "chapter-9", title: "Chapter 9: Straight Lines", storagePath: "lectures/class11/math/straight-lines", dpps: [], tests: [], lectures: [] },
  { id: "chapter-10", title: "Chapter 10: Conic Sections", storagePath: "lectures/class11/math/conics", dpps: [], tests: [], lectures: [] },
  { id: "chapter-11", title: "Chapter 11: Introduction to 3D Geometry", storagePath: "lectures/class11/math/3d", dpps: [], tests: [], lectures: [] },
  { id: "chapter-12", title: "Chapter 12: Limits & Derivatives", storagePath: "lectures/class11/math/limits", dpps: [], tests: [], lectures: [] },
  { id: "chapter-13", title: "Chapter 13: Statistics", storagePath: "lectures/class11/math/stats", dpps: [], tests: [], lectures: [] },
  { id: "chapter-14", title: "Chapter 14: Probability", storagePath: "lectures/class11/math/probability", dpps: [], tests: [], lectures: [] },
];

const class10_mathematics_chapters = [
  {
        id: "chapter-1-real-numbers",
        title: "Chapter 1: Real Numbers",
        storagePath: "lectures/class10/math/real-numbers",
        dpps: [
          { name: "M1. Practice: Fundamental Theorem of Arithmetic", fileName: "Real_Numbers_DPP1.pdf" },
          { name: "M2. Practice: Irrationality Proofs (∁E, ∁E, ∁E)", fileName: "Real_Numbers_DPP2.pdf" }
        ],
        tests: [
          { name: "T1. Euclid’s Division & LCM/HCF Test", testId: "m10_ch1_t1" },
          { name: "T2. Chapter MCQ Assessment", testId: "m10_ch1_t2" }
        ],
        lectures: [
          { id: "m10-001", title: "L1. Introduction to Real Numbers", fileName: "L1_RealNumbers.mp4" },
          { id: "m10-002", title: "L2. Rational & Irrational Proofs", fileName: "L2_Irrational.mp4" },
        ],
      },
      {
        id: "chapter-2-polynomials",
        title: "Chapter 2: Polynomials",
        storagePath: "lectures/class10/math/polynomials",
        dpps: [
          { name: "M1. Practice: Geometrical Meaning of Zeroes", fileName: "Poly_DPP1.pdf" },
          { name: "M2. Practice: Relationship between Coefficients", fileName: "Poly_DPP2.pdf" }
        ],
        tests: [
          { name: "T1. Zeroes & Coefficients Test", testId: "m10_ch2_t1" },
          { name: "T2. Division Algorithm Test", testId: "m10_ch2_t2" }
        ],
        lectures: [
          { id: "m10-003", title: "L1. Zeroes of a Polynomial", fileName: "L1_Zeroes.mp4" },
          { id: "m10-004", title: "L2. Quadratic Polynomials Construction", fileName: "L2_Quadratic.mp4" },
        ],
      },
      { id: "chapter-3-linear-equations", title: "Chapter 3: Pair of Linear Equations in Two Variables", storagePath: "lectures/class10/math/linear-eq", dpps: [], tests: [], lectures: [] },
      { id: "chapter-4-quadratic", title: "Chapter 4: Quadratic Equations", storagePath: "lectures/class10/math/quad-eq", dpps: [], tests: [], lectures: [] },
      { id: "chapter-5-ap", title: "Chapter 5: Arithmetic Progressions", storagePath: "lectures/class10/math/ap", dpps: [], tests: [], lectures: [] },
 
      { id: "chapter-6-triangles", title: "Chapter 6: Triangles (Similar Figures)", storagePath: "lectures/class10/math/triangles", dpps: [], tests: [], lectures: [] },
      { id: "chapter-7-coord", title: "Chapter 7: Coordinate Geometry", storagePath: "lectures/class10/math/coord-geom", dpps: [], tests: [], lectures: [] },
      { id: "chapter-8-trigo", title: "Chapter 8: Introduction to Trigonometry", storagePath: "lectures/class10/math/trigo", dpps: [], tests: [], lectures: [] },
      { id: "chapter-9-app-trigo", title: "Chapter 9: Some Applications of Trigonometry", storagePath: "lectures/class10/math/height-distance", dpps: [], tests: [], lectures: [] },

      { id: "chapter-10-circles", title: "Chapter 10: Circles (Tangents)", storagePath: "lectures/class10/math/circles", dpps: [], tests: [], lectures: [] },
      { id: "chapter-11-areas", title: "Chapter 11: Areas Related to Circles", storagePath: "lectures/class10/math/areas", dpps: [], tests: [], lectures: [] },
      { id: "chapter-12-volume", title: "Chapter 12: Surface Areas and Volumes", storagePath: "lectures/class10/math/volume", dpps: [], tests: [], lectures: [] },
      { id: "chapter-13-stats", title: "Chapter 13: Statistics", storagePath: "lectures/class10/math/stats", dpps: [], tests: [], lectures: [] },
      { id: "chapter-14-prob", title: "Chapter 14: Probability", storagePath: "lectures/class10/math/probability", dpps: [], tests: [], lectures: [] },

];

const class10_science_chapters = [
  {
        id: "chapter-1-chem-reactions",
        title: "Chapter 1: Chemical Reactions & Equations",
        storagePath: "lectures/class10/science/chem-reactions",
        dpps: [
          { name: "S1. Practice: Balancing Chemical Equations", fileName: "Chem_Eq_DPP1.pdf" },
          { name: "S2. Practice: Types of Reactions (Redox/Displacement)", fileName: "Chem_Eq_DPP2.pdf" }
        ],
        tests: [
          { name: "T1. Balancing & Equation Basics", testId: "s10_ch1_t1" },
          { name: "T2. Displacement & Oxidation Test", testId: "s10_ch1_t2" }
        ],
        lectures: [
          { id: "s10-001", title: "L1. How to Balance Any Equation", fileName: "L1_Balancing.mp4" },
          { id: "s10-002", title: "L2. Combination and Decomposition", fileName: "L2_Types.mp4" },
        ],
      },
      {
        id: "chapter-2-acids-bases",
        title: "Chapter 2: Acids, Bases and Salts",
        storagePath: "lectures/class10/science/acids-bases",
        dpps: [
          { name: "S1. Practice: pH Scale & Indicators", fileName: "Acids_DPP1.pdf" },
          { name: "S2. Practice: Common Salts & Chemicals", fileName: "Acids_DPP2.pdf" }
        ],
        tests: [
          { name: "T1. Acid-Base Neutralization Test", testId: "s10_ch2_t1" },
          { name: "T2. Preparation of Salts (Plaster of Paris/Soda)", testId: "s10_ch2_t2" }
        ],
        lectures: [
          { id: "s10-003", title: "L1. Properties of Acids and Bases", fileName: "L1_Acids.mp4" },
          { id: "s10-004", title: "L2. Importance of pH in Daily Life", fileName: "L2_pH.mp4" },
        ],
      },
      { id: "chapter-3-metals", title: "Chapter 3: Metals and Non-Metals", storagePath: "lectures/class10/science/metals", dpps: [], tests: [], lectures: [] },
      { id: "chapter-4-carbon", title: "Chapter 4: Carbon and its Compounds", storagePath: "lectures/class10/science/carbon", dpps: [], tests: [], lectures: [] },

      { id: "chapter-5-life-processes", title: "Chapter 5: Life Processes", storagePath: "lectures/class10/science/life-processes", dpps: [], tests: [], lectures: [] },
      { id: "chapter-6-control", title: "Chapter 6: Control and Coordination", storagePath: "lectures/class10/science/control", dpps: [], tests: [], lectures: [] },
      { id: "chapter-7-repro", title: "Chapter 7: How do Organisms Reproduce?", storagePath: "lectures/class10/science/reproduction", dpps: [], tests: [], lectures: [] },
      { id: "chapter-8-heredity", title: "Chapter 8: Heredity and Evolution", storagePath: "lectures/class10/science/heredity", dpps: [], tests: [], lectures: [] },
      { id: "chapter-9-light", title: "Chapter 9: Light - Reflection and Refraction", storagePath: "lectures/class10/science/light", dpps: [], tests: [], lectures: [] },
      { id: "chapter-10-eye", title: "Chapter 10: Human Eye and Colourful World", storagePath: "lectures/class10/science/human-eye", dpps: [], tests: [], lectures: [] },
      { id: "chapter-11-electricity", title: "Chapter 11: Electricity", storagePath: "lectures/class10/science/electricity", dpps: [], tests: [], lectures: [] },
      { id: "chapter-12-magnetic", title: "Chapter 12: Magnetic Effects of Electric Current", storagePath: "lectures/class10/science/magnetic-effects", dpps: [], tests: [], lectures: [] },
];

const class10_english_chapters = [
  {
    id: "chapter-1-prose-the-fun-they-had",
    title: "Chapter 1: Prose - The Fun They Had",
    storagePath: "lectures/class10/english/prose-fun-they-had",
    dpps: [
      { name: "E1. Practice: Comprehension & Vocabulary", fileName: "Eng_Prose1_DPP1.pdf" },
      { name: "E2. Practice: Short Answer Questions", fileName: "Eng_Prose1_DPP2.pdf" }
    ],
    tests: [
      { name: "T1. Reading Comprehension Test", testId: "e10_ch1_t1" },
      { name: "T2. Chapter MCQ Assessment", testId: "e10_ch1_t2" }
    ],
    lectures: [
      { id: "e10-001", title: "L1. Story Walkthrough & Theme", fileName: "L1_FunTheyHad.mp4" },
      { id: "e10-002", title: "L2. Character Analysis & Q/A", fileName: "L2_FunTheyHad_QA.mp4" },
    ],
  },
  {
    id: "chapter-2-poetry-the-road-not-taken",
    title: "Chapter 2: Poetry - The Road Not Taken",
    storagePath: "lectures/class10/english/poetry-road-not-taken",
    dpps: [
      { name: "E1. Practice: Poetic Devices", fileName: "Eng_Poetry1_DPP1.pdf" },
      { name: "E2. Practice: Theme & Tone", fileName: "Eng_Poetry1_DPP2.pdf" }
    ],
    tests: [
      { name: "T1. Poem Comprehension Test", testId: "e10_ch2_t1" },
      { name: "T2. Figures of Speech Test", testId: "e10_ch2_t2" }
    ],
    lectures: [
      { id: "e10-003", title: "L1. Line-by-Line Explanation", fileName: "L1_RoadNotTaken.mp4" },
      { id: "e10-004", title: "L2. Theme, Symbolism & Devices", fileName: "L2_RoadNotTaken_Devices.mp4" },
    ],
  },
  { id: "chapter-3-prose-the-sound-of-music", title: "Chapter 3: Prose - The Sound of Music", storagePath: "lectures/class10/english/sound-of-music", dpps: [], tests: [], lectures: [] },
  { id: "chapter-4-poetry-wind", title: "Chapter 4: Poetry - Wind", storagePath: "lectures/class10/english/wind", dpps: [], tests: [], lectures: [] },
  { id: "chapter-5-prose-the-little-girl", title: "Chapter 5: Prose - The Little Girl", storagePath: "lectures/class10/english/little-girl", dpps: [], tests: [], lectures: [] },
  { id: "chapter-6-poetry-rain-on-the-roof", title: "Chapter 6: Poetry - Rain on the Roof", storagePath: "lectures/class10/english/rain-on-roof", dpps: [], tests: [], lectures: [] },
  { id: "chapter-7-prose-a-truly-beautiful-mind", title: "Chapter 7: Prose - A Truly Beautiful Mind", storagePath: "lectures/class10/english/beautiful-mind", dpps: [], tests: [], lectures: [] },
  { id: "chapter-8-poetry-the-lake-isle", title: "Chapter 8: Poetry - The Lake Isle of Innisfree", storagePath: "lectures/class10/english/lake-isle", dpps: [], tests: [], lectures: [] },
  { id: "chapter-9-supplementary-the-lost-child", title: "Chapter 9: Supplementary - The Lost Child", storagePath: "lectures/class10/english/lost-child", dpps: [], tests: [], lectures: [] },
  { id: "chapter-10-grammar-tenses", title: "Chapter 10: Grammar - Tenses", storagePath: "lectures/class10/english/grammar-tenses", dpps: [], tests: [], lectures: [] },
  { id: "chapter-11-grammar-modals", title: "Chapter 11: Grammar - Modals & Voice", storagePath: "lectures/class10/english/grammar-modals", dpps: [], tests: [], lectures: [] },
  { id: "chapter-12-writing-letter-essay", title: "Chapter 12: Writing - Letters, Essays & Reports", storagePath: "lectures/class10/english/writing", dpps: [], tests: [], lectures: [] },
];

const class9_mathematics_chapters = [
  {
        id: "chapter-1-real-numbers",
        title: "Chapter 1: Real Numbers",
        storagePath: "lectures/class10/math/real-numbers",
        dpps: [
          { name: "M1. Practice: Fundamental Theorem of Arithmetic", fileName: "Real_Numbers_DPP1.pdf" },
          { name: "M2. Practice: Irrationality Proofs (√2, √3, √5)", fileName: "Real_Numbers_DPP2.pdf" }
        ],
        tests: [
          { name: "T1. Euclid’s Division & LCM/HCF Test", testId: "m10_ch1_t1" },
          { name: "T2. Chapter MCQ Assessment", testId: "m10_ch1_t2" }
        ],
        lectures: [
          { id: "m10-001", title: "L1. Introduction to Real Numbers", fileName: "L1_RealNumbers.mp4" },
          { id: "m10-002", title: "L2. Rational & Irrational Proofs", fileName: "L2_Irrational.mp4" },
        ],
      },
      {
        id: "chapter-2-polynomials",
        title: "Chapter 2: Polynomials",
        storagePath: "lectures/class10/math/polynomials",
        dpps: [
          { name: "M1. Practice: Geometrical Meaning of Zeroes", fileName: "Poly_DPP1.pdf" },
          { name: "M2. Practice: Relationship between Coefficients", fileName: "Poly_DPP2.pdf" }
        ],
        tests: [
          { name: "T1. Zeroes & Coefficients Test", testId: "m10_ch2_t1" },
          { name: "T2. Division Algorithm Test", testId: "m10_ch2_t2" }
        ],
        lectures: [
          { id: "m10-003", title: "L1. Zeroes of a Polynomial", fileName: "L1_Zeroes.mp4" },
          { id: "m10-004", title: "L2. Quadratic Polynomials Construction", fileName: "L2_Quadratic.mp4" },
        ],
      },
      { id: "chapter-3-linear-equations", title: "Chapter 3: Pair of Linear Equations in Two Variables", storagePath: "lectures/class10/math/linear-eq", dpps: [], tests: [], lectures: [] },
      { id: "chapter-4-quadratic", title: "Chapter 4: Quadratic Equations", storagePath: "lectures/class10/math/quad-eq", dpps: [], tests: [], lectures: [] },
      { id: "chapter-5-ap", title: "Chapter 5: Arithmetic Progressions", storagePath: "lectures/class10/math/ap", dpps: [], tests: [], lectures: [] },
 
      { id: "chapter-6-triangles", title: "Chapter 6: Triangles (Similar Figures)", storagePath: "lectures/class10/math/triangles", dpps: [], tests: [], lectures: [] },
      { id: "chapter-7-coord", title: "Chapter 7: Coordinate Geometry", storagePath: "lectures/class10/math/coord-geom", dpps: [], tests: [], lectures: [] },
      { id: "chapter-8-trigo", title: "Chapter 8: Introduction to Trigonometry", storagePath: "lectures/class10/math/trigo", dpps: [], tests: [], lectures: [] },
      { id: "chapter-9-app-trigo", title: "Chapter 9: Some Applications of Trigonometry", storagePath: "lectures/class10/math/height-distance", dpps: [], tests: [], lectures: [] },

      { id: "chapter-10-circles", title: "Chapter 10: Circles (Tangents)", storagePath: "lectures/class10/math/circles", dpps: [], tests: [], lectures: [] },
      { id: "chapter-11-areas", title: "Chapter 11: Areas Related to Circles", storagePath: "lectures/class10/math/areas", dpps: [], tests: [], lectures: [] },
      { id: "chapter-12-volume", title: "Chapter 12: Surface Areas and Volumes", storagePath: "lectures/class10/math/volume", dpps: [], tests: [], lectures: [] },
      { id: "chapter-13-stats", title: "Chapter 13: Statistics", storagePath: "lectures/class10/math/stats", dpps: [], tests: [], lectures: [] },
      { id: "chapter-14-prob", title: "Chapter 14: Probability", storagePath: "lectures/class10/math/probability", dpps: [], tests: [], lectures: [] },

];

const class9_english_chapters = [
  {
    id: "chapter-1-prose-the-fun-they-had",
    title: "Chapter 1: Prose - The Fun They Had",
    storagePath: "lectures/class9/english/prose-fun-they-had",
    dpps: [
      { name: "E1. Practice: Comprehension & Vocabulary", fileName: "Eng_Prose1_DPP1.pdf" },
      { name: "E2. Practice: Short Answer Questions", fileName: "Eng_Prose1_DPP2.pdf" }
    ],
    tests: [
      { name: "T1. Reading Comprehension Test", testId: "e10_ch1_t1" },
      { name: "T2. Chapter MCQ Assessment", testId: "e10_ch1_t2" }
    ],
    lectures: [
      { id: "e10-001", title: "L1. Story Walkthrough & Theme", fileName: "L1_FunTheyHad.mp4" },
      { id: "e10-002", title: "L2. Character Analysis & Q/A", fileName: "L2_FunTheyHad_QA.mp4" },
    ],
  },
  {
    id: "chapter-2-poetry-the-road-not-taken",
    title: "Chapter 2: Poetry - The Road Not Taken",
    storagePath: "lectures/class9/english/poetry-road-not-taken",
    dpps: [
      { name: "E1. Practice: Poetic Devices", fileName: "Eng_Poetry1_DPP1.pdf" },
      { name: "E2. Practice: Theme & Tone", fileName: "Eng_Poetry1_DPP2.pdf" }
    ],
    tests: [
      { name: "T1. Poem Comprehension Test", testId: "e10_ch2_t1" },
      { name: "T2. Figures of Speech Test", testId: "e10_ch2_t2" }
    ],
    lectures: [
      { id: "e10-003", title: "L1. Line-by-Line Explanation", fileName: "L1_RoadNotTaken.mp4" },
      { id: "e10-004", title: "L2. Theme, Symbolism & Devices", fileName: "L2_RoadNotTaken_Devices.mp4" },
    ],
  },
  { id: "chapter-3-prose-the-sound-of-music", title: "Chapter 3: Prose - The Sound of Music", storagePath: "lectures/class9/english/sound-of-music", dpps: [], tests: [], lectures: [] },
  { id: "chapter-4-poetry-wind", title: "Chapter 4: Poetry - Wind", storagePath: "lectures/class9/english/wind", dpps: [], tests: [], lectures: [] },
  { id: "chapter-5-prose-the-little-girl", title: "Chapter 5: Prose - The Little Girl", storagePath: "lectures/class9/english/little-girl", dpps: [], tests: [], lectures: [] },
  { id: "chapter-6-poetry-rain-on-the-roof", title: "Chapter 6: Poetry - Rain on the Roof", storagePath: "lectures/class9/english/rain-on-roof", dpps: [], tests: [], lectures: [] },
  { id: "chapter-7-prose-a-truly-beautiful-mind", title: "Chapter 7: Prose - A Truly Beautiful Mind", storagePath: "lectures/class9/english/beautiful-mind", dpps: [], tests: [], lectures: [] },
  { id: "chapter-8-poetry-the-lake-isle", title: "Chapter 8: Poetry - The Lake Isle of Innisfree", storagePath: "lectures/class9/english/lake-isle", dpps: [], tests: [], lectures: [] },
  { id: "chapter-9-supplementary-the-lost-child", title: "Chapter 9: Supplementary - The Lost Child", storagePath: "lectures/class9/english/lost-child", dpps: [], tests: [], lectures: [] },
  { id: "chapter-10-grammar-tenses", title: "Chapter 10: Grammar - Tenses", storagePath: "lectures/class9/english/grammar-tenses", dpps: [], tests: [], lectures: [] },
  { id: "chapter-11-grammar-modals", title: "Chapter 11: Grammar - Modals & Voice", storagePath: "lectures/class9/english/grammar-modals", dpps: [], tests: [], lectures: [] },
  { id: "chapter-12-writing-letter-essay", title: "Chapter 12: Writing - Letters, Essays & Reports", storagePath: "lectures/class9/english/writing", dpps: [], tests: [], lectures: [] },
];

const class8_english_chapters = [
  {
    id: "chapter-1-prose-the-fun-they-had",
    title: "Chapter 1: Prose - The Fun They Had",
    storagePath: "lectures/class8/english/prose-fun-they-had",
    dpps: [
      { name: "E1. Practice: Comprehension & Vocabulary", fileName: "Eng_Prose1_DPP1.pdf" },
      { name: "E2. Practice: Short Answer Questions", fileName: "Eng_Prose1_DPP2.pdf" }
    ],
    tests: [
      { name: "T1. Reading Comprehension Test", testId: "e10_ch1_t1" },
      { name: "T2. Chapter MCQ Assessment", testId: "e10_ch1_t2" }
    ],
    lectures: [
      { id: "e10-001", title: "L1. Story Walkthrough & Theme", fileName: "L1_FunTheyHad.mp4" },
      { id: "e10-002", title: "L2. Character Analysis & Q/A", fileName: "L2_FunTheyHad_QA.mp4" },
    ],
  },
  {
    id: "chapter-2-poetry-the-road-not-taken",
    title: "Chapter 2: Poetry - The Road Not Taken",
    storagePath: "lectures/class8/english/poetry-road-not-taken",
    dpps: [
      { name: "E1. Practice: Poetic Devices", fileName: "Eng_Poetry1_DPP1.pdf" },
      { name: "E2. Practice: Theme & Tone", fileName: "Eng_Poetry1_DPP2.pdf" }
    ],
    tests: [
      { name: "T1. Poem Comprehension Test", testId: "e10_ch2_t1" },
      { name: "T2. Figures of Speech Test", testId: "e10_ch2_t2" }
    ],
    lectures: [
      { id: "e10-003", title: "L1. Line-by-Line Explanation", fileName: "L1_RoadNotTaken.mp4" },
      { id: "e10-004", title: "L2. Theme, Symbolism & Devices", fileName: "L2_RoadNotTaken_Devices.mp4" },
    ],
  },
  { id: "chapter-3-prose-the-sound-of-music", title: "Chapter 3: Prose - The Sound of Music", storagePath: "lectures/class8/english/sound-of-music", dpps: [], tests: [], lectures: [] },
  { id: "chapter-4-poetry-wind", title: "Chapter 4: Poetry - Wind", storagePath: "lectures/class8/english/wind", dpps: [], tests: [], lectures: [] },
  { id: "chapter-5-prose-the-little-girl", title: "Chapter 5: Prose - The Little Girl", storagePath: "lectures/class8/english/little-girl", dpps: [], tests: [], lectures: [] },
  { id: "chapter-6-poetry-rain-on-the-roof", title: "Chapter 6: Poetry - Rain on the Roof", storagePath: "lectures/class8/english/rain-on-roof", dpps: [], tests: [], lectures: [] },
  { id: "chapter-7-prose-a-truly-beautiful-mind", title: "Chapter 7: Prose - A Truly Beautiful Mind", storagePath: "lectures/class8/english/beautiful-mind", dpps: [], tests: [], lectures: [] },
  { id: "chapter-8-poetry-the-lake-isle", title: "Chapter 8: Poetry - The Lake Isle of Innisfree", storagePath: "lectures/class8/english/lake-isle", dpps: [], tests: [], lectures: [] },
  { id: "chapter-9-supplementary-the-lost-child", title: "Chapter 9: Supplementary - The Lost Child", storagePath: "lectures/class8/english/lost-child", dpps: [], tests: [], lectures: [] },
  { id: "chapter-10-grammar-tenses", title: "Chapter 10: Grammar - Tenses", storagePath: "lectures/class8/english/grammar-tenses", dpps: [], tests: [], lectures: [] },
  { id: "chapter-11-grammar-modals", title: "Chapter 11: Grammar - Modals & Voice", storagePath: "lectures/class8/english/grammar-modals", dpps: [], tests: [], lectures: [] },
  { id: "chapter-12-writing-letter-essay", title: "Chapter 12: Writing - Letters, Essays & Reports", storagePath: "lectures/class8/english/writing", dpps: [], tests: [], lectures: [] },
];

const class7_english_chapters = [
  {
    id: "chapter-1-prose-the-fun-they-had",
    title: "Chapter 1: Prose - The Fun They Had",
    storagePath: "lectures/class7/english/prose-fun-they-had",
    dpps: [
      { name: "E1. Practice: Comprehension & Vocabulary", fileName: "Eng_Prose1_DPP1.pdf" },
      { name: "E2. Practice: Short Answer Questions", fileName: "Eng_Prose1_DPP2.pdf" }
    ],
    tests: [
      { name: "T1. Reading Comprehension Test", testId: "e10_ch1_t1" },
      { name: "T2. Chapter MCQ Assessment", testId: "e10_ch1_t2" }
    ],
    lectures: [
      { id: "e10-001", title: "L1. Story Walkthrough & Theme", fileName: "L1_FunTheyHad.mp4" },
      { id: "e10-002", title: "L2. Character Analysis & Q/A", fileName: "L2_FunTheyHad_QA.mp4" },
    ],
  },
  {
    id: "chapter-2-poetry-the-road-not-taken",
    title: "Chapter 2: Poetry - The Road Not Taken",
    storagePath: "lectures/class7/english/poetry-road-not-taken",
    dpps: [
      { name: "E1. Practice: Poetic Devices", fileName: "Eng_Poetry1_DPP1.pdf" },
      { name: "E2. Practice: Theme & Tone", fileName: "Eng_Poetry1_DPP2.pdf" }
    ],
    tests: [
      { name: "T1. Poem Comprehension Test", testId: "e10_ch2_t1" },
      { name: "T2. Figures of Speech Test", testId: "e10_ch2_t2" }
    ],
    lectures: [
      { id: "e10-003", title: "L1. Line-by-Line Explanation", fileName: "L1_RoadNotTaken.mp4" },
      { id: "e10-004", title: "L2. Theme, Symbolism & Devices", fileName: "L2_RoadNotTaken_Devices.mp4" },
    ],
  },
  { id: "chapter-3-prose-the-sound-of-music", title: "Chapter 3: Prose - The Sound of Music", storagePath: "lectures/class7/english/sound-of-music", dpps: [], tests: [], lectures: [] },
  { id: "chapter-4-poetry-wind", title: "Chapter 4: Poetry - Wind", storagePath: "lectures/class7/english/wind", dpps: [], tests: [], lectures: [] },
  { id: "chapter-5-prose-the-little-girl", title: "Chapter 5: Prose - The Little Girl", storagePath: "lectures/class7/english/little-girl", dpps: [], tests: [], lectures: [] },
  { id: "chapter-6-poetry-rain-on-the-roof", title: "Chapter 6: Poetry - Rain on the Roof", storagePath: "lectures/class7/english/rain-on-roof", dpps: [], tests: [], lectures: [] },
  { id: "chapter-7-prose-a-truly-beautiful-mind", title: "Chapter 7: Prose - A Truly Beautiful Mind", storagePath: "lectures/class7/english/beautiful-mind", dpps: [], tests: [], lectures: [] },
  { id: "chapter-8-poetry-the-lake-isle", title: "Chapter 8: Poetry - The Lake Isle of Innisfree", storagePath: "lectures/class7/english/lake-isle", dpps: [], tests: [], lectures: [] },
  { id: "chapter-9-supplementary-the-lost-child", title: "Chapter 9: Supplementary - The Lost Child", storagePath: "lectures/class7/english/lost-child", dpps: [], tests: [], lectures: [] },
  { id: "chapter-10-grammar-tenses", title: "Chapter 10: Grammar - Tenses", storagePath: "lectures/class7/english/grammar-tenses", dpps: [], tests: [], lectures: [] },
  { id: "chapter-11-grammar-modals", title: "Chapter 11: Grammar - Modals & Voice", storagePath: "lectures/class7/english/grammar-modals", dpps: [], tests: [], lectures: [] },
  { id: "chapter-12-writing-letter-essay", title: "Chapter 12: Writing - Letters, Essays & Reports", storagePath: "lectures/class7/english/writing", dpps: [], tests: [], lectures: [] },
];

const class6_english_chapters = [
  {
    id: "chapter-1-prose-the-fun-they-had",
    title: "Chapter 1: Prose - The Fun They Had",
    storagePath: "lectures/class6/english/prose-fun-they-had",
    dpps: [
      { name: "E1. Practice: Comprehension & Vocabulary", fileName: "Eng_Prose1_DPP1.pdf" },
      { name: "E2. Practice: Short Answer Questions", fileName: "Eng_Prose1_DPP2.pdf" }
    ],
    tests: [
      { name: "T1. Reading Comprehension Test", testId: "e10_ch1_t1" },
      { name: "T2. Chapter MCQ Assessment", testId: "e10_ch1_t2" }
    ],
    lectures: [
      { id: "e10-001", title: "L1. Story Walkthrough & Theme", fileName: "L1_FunTheyHad.mp4" },
      { id: "e10-002", title: "L2. Character Analysis & Q/A", fileName: "L2_FunTheyHad_QA.mp4" },
    ],
  },
  {
    id: "chapter-2-poetry-the-road-not-taken",
    title: "Chapter 2: Poetry - The Road Not Taken",
    storagePath: "lectures/class6/english/poetry-road-not-taken",
    dpps: [
      { name: "E1. Practice: Poetic Devices", fileName: "Eng_Poetry1_DPP1.pdf" },
      { name: "E2. Practice: Theme & Tone", fileName: "Eng_Poetry1_DPP2.pdf" }
    ],
    tests: [
      { name: "T1. Poem Comprehension Test", testId: "e10_ch2_t1" },
      { name: "T2. Figures of Speech Test", testId: "e10_ch2_t2" }
    ],
    lectures: [
      { id: "e10-003", title: "L1. Line-by-Line Explanation", fileName: "L1_RoadNotTaken.mp4" },
      { id: "e10-004", title: "L2. Theme, Symbolism & Devices", fileName: "L2_RoadNotTaken_Devices.mp4" },
    ],
  },
  { id: "chapter-3-prose-the-sound-of-music", title: "Chapter 3: Prose - The Sound of Music", storagePath: "lectures/class6/english/sound-of-music", dpps: [], tests: [], lectures: [] },
  { id: "chapter-4-poetry-wind", title: "Chapter 4: Poetry - Wind", storagePath: "lectures/class6/english/wind", dpps: [], tests: [], lectures: [] },
  { id: "chapter-5-prose-the-little-girl", title: "Chapter 5: Prose - The Little Girl", storagePath: "lectures/class6/english/little-girl", dpps: [], tests: [], lectures: [] },
  { id: "chapter-6-poetry-rain-on-the-roof", title: "Chapter 6: Poetry - Rain on the Roof", storagePath: "lectures/class6/english/rain-on-roof", dpps: [], tests: [], lectures: [] },
  { id: "chapter-7-prose-a-truly-beautiful-mind", title: "Chapter 7: Prose - A Truly Beautiful Mind", storagePath: "lectures/class6/english/beautiful-mind", dpps: [], tests: [], lectures: [] },
  { id: "chapter-8-poetry-the-lake-isle", title: "Chapter 8: Poetry - The Lake Isle of Innisfree", storagePath: "lectures/class6/english/lake-isle", dpps: [], tests: [], lectures: [] },
  { id: "chapter-9-supplementary-the-lost-child", title: "Chapter 9: Supplementary - The Lost Child", storagePath: "lectures/class6/english/lost-child", dpps: [], tests: [], lectures: [] },
  { id: "chapter-10-grammar-tenses", title: "Chapter 10: Grammar - Tenses", storagePath: "lectures/class6/english/grammar-tenses", dpps: [], tests: [], lectures: [] },
  { id: "chapter-11-grammar-modals", title: "Chapter 11: Grammar - Modals & Voice", storagePath: "lectures/class6/english/grammar-modals", dpps: [], tests: [], lectures: [] },
  { id: "chapter-12-writing-letter-essay", title: "Chapter 12: Writing - Letters, Essays & Reports", storagePath: "lectures/class6/english/writing", dpps: [], tests: [], lectures: [] },
];

export const SUBJECT_CHAPTERS = {
  ...Object.fromEntries(TUTORIAL_SUBJECTS.filter(subject => subject.comingSoon).map(subject => [subject.subjectKey, []])),
  'iitjee-physics': iitjee_physics_sections.flatMap(section => section.chapters),
  'iitjee-chemistry': iitjee_chemistry_sections.flatMap(section => section.chapters),
  'iitjee-mathematics': iitjee_mathematics_sections.flatMap(section => section.chapters),
  'class12-physics': class12_physics_chapters,
  'class12-chemistry': class12_chemistry_chapters,
  'class12-mathematics': class12_mathematics_chapters,
  'class11-physics': class12_physics_chapters,
  'class11-chemistry': class11_chemistry_chapters,
  'class11-mathematics': class11_mathematics_chapters,
  'class10-mathematics': class10_mathematics_chapters,
  'class10-science': class10_science_chapters,
  'class10-english': class10_english_chapters,
  'class9-mathematics': class9_mathematics_chapters,
  'class9-science': class10_science_chapters,
  'class9-english': class9_english_chapters,
  'class8-mathematics': class10_mathematics_chapters,
  'class8-science': class10_science_chapters,
  'class8-english': class8_english_chapters,
  'class7-mathematics': class9_mathematics_chapters,
  'class7-science': class10_science_chapters,
  'class7-english': class7_english_chapters,
  'class6-mathematics': class10_mathematics_chapters,
  'class6-science': class10_science_chapters,
  'class6-english': class6_english_chapters,
};

export const LOWER_MATH_CHAPTERS = SUBJECT_CHAPTERS['class10-mathematics'];
export const LOWER_SCIENCE_CHAPTERS = SUBJECT_CHAPTERS['class10-science'];
// ─── Pure stats helper ────────────────────────────────────────────────────────

/**
 * Compute accurate done/total progress for a single subject.
 *
 * @param {string} subjectKey  e.g. "iitjee-physics"
 * @param {Object} allProgress  The allProgress map from useAllProgress()
 *   Shape: { [subjectKey]: { [chapterId]: { lectures:{}, dpps:{}, tests:{} } } }
 * @returns {{ done: number, total: number, pct: number }}
 */
export function computeSubjectStats(subjectKey, allProgress) {
  const chapters = SUBJECT_CHAPTERS[subjectKey] || [];
  let done = 0, total = 0;
  const sp = allProgress?.[subjectKey] || {};

  chapters.forEach(ch => {
    const cp = sp[ch.id] || {};
    const lecs  = cp.lectures || {};
    const dpps  = cp.dpps    || {};
    const tests = cp.tests   || {};

    (ch.lectures || []).forEach(l => { total++; if (lecs[l.id]?.done)      done++; });
    (ch.dpps     || []).forEach(d => { total++; if (dpps[d.fileName]?.done) done++; });
    (ch.tests    || []).forEach(t => { total++; if (tests[t.testId]?.completed) done++; });
  });

  return { done, total, pct: total > 0 ? Math.round((done / total) * 100) : 0 };
}
